import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "input",
    "uploadState",
    "fileName",
    "fileSize",
    "progressContainer",
    "percentage",
    "errorContainer",
    "errorFileName",
    "errorFileSize",
    "errorMessage",
  ]

  connect() {
    this.validTypes = [".pdf", ".csv", ".txt"]
    this.maxSize = 30 * 1024 * 1024

    this._onSubmitEnd = () => {
      clearInterval(this.timer)
      if (this.hasPercentageTarget) this.percentageTarget.style.width = "100%"
      this._hideTimeout = setTimeout(() => {
        if (this.hasProgressContainerTarget)
          this.toggle(this.progressContainerTarget, false)
      }, 400)
      if (this.hasUploadStateTarget) this.toggle(this.uploadStateTarget, true)
    }

    this.inputTarget.form.addEventListener(
      "turbo:submit-end",
      this._onSubmitEnd,
    )
  }

  disconnect() {
    this.inputTarget.form.removeEventListener(
      "turbo:submit-end",
      this._onSubmitEnd,
    )
    clearInterval(this.timer)
    clearTimeout(this._hideTimeout)
  }

  // Opens file picker when clicked on the "browse file" button also clears previous errors
  browseFile() {
    this.clearError()
    this.inputTarget.click()
  }

  validate(e) {
    const file = e.target.files[0]
    if (file) this.handleFile(file)
  }

  // Required so that browser allows file dropping
  allowFileDrop(e) {
    e.preventDefault()
  }

  drop(e) {
    e.preventDefault()
    const file = e.dataTransfer.files[0]
    if (!file) return
    this.inputTarget.files = e.dataTransfer.files
    this.handleFile(file)
  }

  handleFile(file) {
    const ext = "." + file.name.split(".").pop().toLowerCase()

    if (!this.validTypes.includes(ext))
      return this.showError(file, "Only PDF, CSV, or TXT files allowed")

    if (file.size > this.maxSize)
      return this.showError(file, "File exceeds 30MB")

    this.fileNameTarget.textContent = file.name
    this.fileSizeTarget.textContent = this.formatSize(file.size)

    this.toggle(this.uploadStateTarget, false)
    this.toggle(this.progressContainerTarget, true)

    let progress = 0
    this.timer = setInterval(() => {
      progress = Math.min(progress + 5, 95)
      this.percentageTarget.style.width = progress + "%"
    }, 100)

    this.inputTarget.form.requestSubmit()
  }

  showError(file, msg) {
    this.errorMessageTarget.textContent = msg
    this.errorFileNameTarget.textContent = file.name
    this.errorFileSizeTarget.textContent = this.formatSize(file.size)

    this.toggle(this.uploadStateTarget, false)
    this.toggle(this.errorContainerTarget, true)
  }

  clearError() {
    this.toggle(this.errorContainerTarget, false)
    this.toggle(this.uploadStateTarget, true)
  }

  toggle(el, show) {
    el.classList.toggle("hidden", !show)
  }

  formatSize(bytes) {
    if (bytes === 0) return "0 B"
    const units = ["B", "KB", "MB", "GB"]
    const i = Math.floor(Math.log(bytes) / Math.log(1024))
    return (bytes / 1024 ** i).toFixed(1) + " " + units[i]
  }
}
